import React, { useState, useEffect } from 'react';

const NAV_LINKS = [
  { id: 'market', label: 'Market' },
  { id: 'appraisal', label: 'Appraisal' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'pricing', label: 'Pricing' },
];

export default function Navbar({ page, setPage }) {
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (dark) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [dark]);

  function nav(id) {
    setPage(id);
    setMenuOpen(false);
  }

  return (
    <>
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 20px', height: 56, background: 'var(--surface)',
        borderBottom: '0.5px solid var(--border)', position: 'sticky', top: 0, zIndex: 100,
      }}>
        {/* Logo */}
        <button onClick={() => nav('market')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'baseline', gap: 3 }}>
          <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 16, fontWeight: 700, letterSpacing: '0.12em', color: '#C0392B' }}>DIAL</span>
          <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 16, fontWeight: 300, letterSpacing: '0.08em', color: 'var(--text2)' }}>MARKET</span>
        </button>

        {/* Desktop nav */}
        <div style={{ display: 'flex', gap: 2, '@media(max-width:640px)': { display: 'none' } }} className="desktop-nav">
          {NAV_LINKS.map(l => (
            <button key={l.id} onClick={() => nav(l.id)} style={{
              fontSize: 13, padding: '6px 12px', borderRadius: 7, border: 'none',
              background: page === l.id ? 'var(--surface2)' : 'transparent',
              color: page === l.id ? 'var(--text)' : 'var(--text2)',
              fontWeight: page === l.id ? 600 : 400,
              fontFamily: "'Space Grotesk', sans-serif", cursor: 'pointer',
            }}>{l.label}{l.id === 'appraisal' && <span style={{ marginLeft: 4, fontSize: 9, background: '#C0392B', color: '#fff', padding: '1px 4px', borderRadius: 99, fontWeight: 700, verticalAlign: 'middle' }}>NEW</span>}</button>
          ))}
        </div>

        {/* Right */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button onClick={() => setDark(v => !v)} style={{ width: 34, height: 34, borderRadius: 8, border: '0.5px solid var(--border2)', background: 'var(--surface2)', cursor: 'pointer', fontSize: 16 }}>
            {dark ? '☀️' : '🌙'}
          </button>
          {/* Mobile hamburger */}
          <button onClick={() => setMenuOpen(v => !v)} className="mobile-menu-btn" style={{ width: 34, height: 34, borderRadius: 8, border: '0.5px solid var(--border2)', background: 'var(--surface2)', cursor: 'pointer', fontSize: 18, display: 'none', alignItems: 'center', justifyContent: 'center' }}>
            <i className={menuOpen ? 'ti ti-x' : 'ti ti-menu-2'} />
          </button>
          {/* Desktop CTA */}
          <button onClick={() => nav('pricing')} className="desktop-cta" style={{ fontSize: 13, padding: '7px 14px', borderRadius: 7, border: 'none', background: 'linear-gradient(135deg, #C0392B, #96281B)', color: '#fff', fontWeight: 600, cursor: 'pointer', fontFamily: "'Space Grotesk', sans-serif", boxShadow: '0 2px 8px rgba(192,57,43,0.3)' }}>
            Get started
          </button>
        </div>
      </nav>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div style={{
          position: 'fixed', top: 56, left: 0, right: 0, zIndex: 99,
          background: 'var(--surface)', borderBottom: '0.5px solid var(--border)',
          padding: '8px 16px 16px',
        }}>
          {NAV_LINKS.map(l => (
            <button key={l.id} onClick={() => nav(l.id)} style={{
              display: 'block', width: '100%', textAlign: 'left',
              padding: '12px 8px', borderRadius: 8, border: 'none',
              background: page === l.id ? 'var(--surface2)' : 'transparent',
              color: page === l.id ? 'var(--text)' : 'var(--text2)',
              fontWeight: page === l.id ? 600 : 400, fontSize: 15,
              fontFamily: "'Space Grotesk', sans-serif", cursor: 'pointer', marginBottom: 2,
            }}>
              {l.label}{l.id === 'appraisal' && <span style={{ marginLeft: 8, fontSize: 10, background: '#C0392B', color: '#fff', padding: '2px 6px', borderRadius: 99, fontWeight: 700 }}>NEW</span>}
            </button>
          ))}
          <button onClick={() => nav('pricing')} style={{ display: 'block', width: '100%', marginTop: 8, padding: '12px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #C0392B, #96281B)', color: '#fff', fontWeight: 600, fontSize: 14, fontFamily: "'Space Grotesk', sans-serif", cursor: 'pointer' }}>
            Get started
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 640px) {
          .desktop-nav { display: none !important; }
          .desktop-cta { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
      `}</style>
    </>
  );
}
